<template>

    <div class="container">

        <app-head title="Mail Log" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Mail Log') }}</h1>
            <div class="">
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="mails.meta" />
        </div>

        <div class="card">
            <data-table :items="mails.data"
                        :links="mails.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="mail in mails.data" :key="mail.id">
                    <td>
                        {{ mail.id }}
                    </td>
                    <td>
                        {{ mail.from }}
                    </td>
                    <td>
                        {{ mail.to }}
                    </td>
                    <td>
                        <inertia-link :href="route('admin.mail-log.show', mail)" class="stretched-link">
                            {{ mail.subject }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ mail.priority }}
                    </td>
                    <td class="text-nowrap">
                        {{ mail.created_at | localizeDateTime }}
                    </td>
                    <td class="text-end">
                        <!--<i class="bi bi-chevron-right"></i>-->
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';
    import Boolean from '@/shared/Admin/Boolean';


    export default {
        props: [
            'filters',
            'mails',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    from: {label: 'From', sortable: 'from'},
                    to: {label: 'To', sortable: 'to'},
                    subject: {label: 'Subject', sortable: 'subject'},
                    priority: {label: 'Priority', sortable: 'priority'},
                    created_at: {label: 'Created', sortable: 'created_at'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.mail-log.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>